import type { RunMetricOutput } from "@/types/RunMetricOutput"

import { parseResultJson } from "../helpers/parseResultJson"

interface PauseAnalysisLegacyResult {
  pause_frequency?: number
  total_pause_duration?: number
  average_pause_duration?: number
  min_pause_duration_seconds?: number
}

interface PauseAnalysisTypedResult {
  count?: number
  frequency?: number
  raw_values?: {
    pause_durations_seconds?: number[]
    total_pause_duration_seconds?: number
    min_pause_duration_seconds?: number
    mad_anomalous_pause_count?: number
    mad_z_score_max?: number
    mad_z_score_threshold?: number
  }
}

interface PauseAnalysisDisplayValues {
  pauseFrequency: number
  totalPauseDuration: number
  averagePauseDuration: number
  minPauseDuration: number
  madAnomalousCount: number | null
  madZScoreMax: number | null
  madZScoreThreshold: number | null
}

export function readPauseAnalysisValues(
  mo: Pick<RunMetricOutput, "result" | "result_json">,
): PauseAnalysisDisplayValues {
  const typed = mo.result as PauseAnalysisTypedResult | null | undefined
  const rawValues = typed?.raw_values
  if (typed?.frequency != null && rawValues != null) {
    const count = typed.count ?? 0
    const totalPauseDuration = rawValues.total_pause_duration_seconds ?? 0
    return {
      pauseFrequency: typed.frequency,
      totalPauseDuration,
      averagePauseDuration: count > 0 ? totalPauseDuration / count : 0,
      minPauseDuration: rawValues.min_pause_duration_seconds ?? 0,
      madAnomalousCount: rawValues.mad_anomalous_pause_count ?? null,
      madZScoreMax: rawValues.mad_z_score_max ?? null,
      madZScoreThreshold: rawValues.mad_z_score_threshold ?? null,
    }
  }

  const legacy = parseResultJson<PauseAnalysisLegacyResult>(mo.result_json)
  return {
    pauseFrequency: legacy?.pause_frequency ?? 0,
    totalPauseDuration: legacy?.total_pause_duration ?? 0,
    averagePauseDuration: legacy?.average_pause_duration ?? 0,
    minPauseDuration: legacy?.min_pause_duration_seconds ?? 0,
    madAnomalousCount: null,
    madZScoreMax: null,
    madZScoreThreshold: null,
  }
}
